import React from 'react'
import Header from "../../../components/header";
import { Stack, EventNoteOutlined, Typography } from "@gti-controls-v2/web-core";
import { useMediaQueryCustom } from '../../../hooks/useMediaQueryCustom/useMediaQueryCustom';
import { fontSize } from '../../../common/constants/UI';
import useTranslation from "../../../hooks/useTranslation";
import { convertDateToSpanish, formatDate } from '../../../common/utilities/dateTime';
import { dateTimeFormatAMPMSlash } from '../../../common/constants/Formatos';

export const ConsumosHeader = (props) => {

    const { isMobile480, isTablet768, isTablet1024 } = useMediaQueryCustom();
    const { t } = useTranslation();

    return (
        <>
            <Header
                icon={<EventNoteOutlined sx={{width: "32px", height: "32px", color: "#f56900"}} />}
                title={`${t("sistema.titulos.iniciocorte")} ${props.corteFecha? convertDateToSpanish(formatDate(props.corteFecha, dateTimeFormatAMPMSlash)): ""}`} 
                aditionalElements={
                    <Stack direction="row" spacing={4}>
                        <Typography 
                            sx={{ lineHeight: 1.2 }} 
                            variant="h6" 
                            fontSize={isMobile480 ? fontSize.isMobile480 : (isTablet768 || isTablet1024) ? "14px" : fontSize.isLaptopDesktop} align="right">
                            {t("sistema.titulos.corte")}
                            <br />
                            {props.corte}
                        </Typography>
                        <Typography 
                            sx={{ lineHeight: 1.2 }} 
                            variant="h6" 
                            fontSize={isMobile480 ? fontSize.isMobile480 : (isTablet768 || isTablet1024) ? "14px" : fontSize.isLaptopDesktop} align="right">
                            {t("sistema.titulos.totalconsumos")}
                            <br />
                            {props.consumosTotal}
                        </Typography>
                    </Stack>
                }
            />
        </>
    )
}
